import axios from "axios";
import { GURL } from "./global";

export const CreateCompany = (model: any) => {
  const url = `${GURL}/company/v1/Company/Create`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};

export const SendAccelerator = (model: any) => {
  const url = `${GURL}/company/v1/Company/SendAccelerator`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(url, model);
};
export const GetMyCompanyAccelerator = () => {
  const url = `${GURL}/company/v1/Company/GetMyCompanyAccelerator`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyCompanyAcceleratorsNoticeIds = () => {
  const url = `${GURL}/company/v1/Company/GetMyCompanyAcceleratorsNoticeIds`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyCompanyAcceleratorsReciver = () => {
  const url = `${GURL}/company/v1/Company/GetMyCompanyAcceleratorsReciver`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyCompanyAcceleratorByBatchId = (batchId: any) => {
  const url = `${GURL}/company/v1/Company/GetMyCompanyAcceleratorByBatchId?BatchId=${batchId}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetMyCompanyAcceleratorByNoticeId = (NoticeId: any) => {
  const url = `${GURL}/company/v1/Company/GetMyCompanyAcceleratorByNoticeId?NoticeId=${NoticeId}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetAllCompanies = () => {
  const url = `${GURL}/company/v1/Company/GetAll`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
export const GetCompanies = () => {
  const url = `${GURL}/company/v1/Company/GetMyCompanies`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};

export const GetCompanyById = (id: any) => {
  const url = `${GURL}/company/v1/Company/GetById?Id=${id}`;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.get(url);
};
